import axios from 'axios';
const domain = window.location.hostname;
var url = '';
switch (domain)
{
  case 'localhost':
    url = 'https://dev.gestione.neurohub.it';
    break;
  case 'demo.neurohub.it':
    url = 'https://test.gestione.neurohub.it';
    break;
  case 'neurohub.it':
  case 'www.neurohub.it':
    url = 'https://gestione.neurohub.it';
    break;
}

const axiosInstance = axios.create({
  baseURL: url + '/api',
  headers: {
    'Content-type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem("token"),
  }
});

export default axiosInstance;